


















































































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import YearMonthPicker from '@/components/datepicker/YearMonthPicker.vue';
import moment from 'moment';
import {
  入出庫照会依頼型,
  入出庫照会在庫場所型,
  入出庫照会結果型,
  入出庫照会絞込条件型,
  入出庫集計取得依頼型バリデータ一覧,
} from '@/type/stock/receiveandreturns/types';
import {ValidationResult} from '@/type/validation/result';
import {progress} from '@/script/progress';
import {loginModule} from '@/store/authentication/login';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';

@Component({
  components: {
    YearMonthPicker,
    ButtonPanel,
    IconButton,
    AlertDialog,
    ConfirmDialog,
    NormalButton,
  },
})

export default class ReceiveAndReturns extends Vue {
  private 在庫場所一覧: 入出庫照会在庫場所型[] = [];
  private 入出庫照会絞込条件: 入出庫照会絞込条件型 = this.検索条件の初期値();
  private 入出庫照会結果: 入出庫照会結果型 | null = null;
  private アラートメッセージ: string | string[] | null = null;
  private バリデーション結果: ValidationResult = new ValidationResult(入出庫集計取得依頼型バリデータ一覧);

  public beforeUpdate(): void {
    if (this.入出庫照会絞込条件 == null) {
      return;
    }
    this.バリデーション結果.validate(this.入出庫照会絞込条件);
  }

  private created(): void {
    this.初期化();
  }

  private 初期化(): void {
    this.在庫場所一覧の取得();
  }

  private async 在庫場所一覧の取得(): Promise<void> {
    this.在庫場所一覧 = await api.入出庫照会在庫場所一覧を取得する();
    this.入出庫照会絞込条件.在庫場所 = this.所属部署コードを取得する;
  }

  get 所属部署コードを取得する(): string {
    return loginModule.部署コードを取得する;
  }

  private async 検索開始(): Promise<void> {
    if (this.バリデーション結果.hasErrors) {
      this.バリデーションエラーを表示する();
      return;
    }

    await progress(this.入出庫集計の取得);
  }

  private async 入出庫集計の取得(): Promise<void> {
    const 入出庫照会依頼: 入出庫照会依頼型 = {
      在庫場所: this.入出庫照会絞込条件.在庫場所,
      在庫年月: this.入出庫照会絞込条件.在庫年月,
    };

    try {
      const 入出庫照会結果: 入出庫照会結果型 = await api.入出庫を照会する(入出庫照会依頼);
      this.入出庫照会結果のクリア();
      this.入出庫照会結果 = 入出庫照会結果;
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  private 入出庫照会結果のクリア(): void {
    this.入出庫照会結果 = null;
  }

  private 検索条件の初期値(): 入出庫照会絞込条件型 {
    const 現在年月 = this.現在年月();
    return {
      在庫場所: '',
      在庫年月: 現在年月,
    };
  }

  @Watch('入出庫照会絞込条件.在庫場所')
  private 在庫場所が変更された(): void {
    const 現在年月 = this.現在年月();
    this.入出庫照会絞込条件.在庫年月 = 現在年月;
  }

  private 現在年月(): string {
    return moment().format('YYYY-MM');
  }

  private get 明細件数を取得() {
    return 0;
  }

  private アラートダイアログを表示する(メッセージ: string | string[]): void {
    if (typeof メッセージ === 'string') {
      this.アラートメッセージ = [メッセージ];
    } else {
      this.アラートメッセージ = メッセージ;
    }
    this.$modal.show('アラート');
  }

  private 確認ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private 確認ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private Excel出力確認ダイアログを開く(): void {
    this.$modal.show('Excel出力確認ダイアログ');
  }

  private Excel出力確認ダイアログを閉じる(): void {
    this.$modal.hide('Excel出力確認ダイアログ');
  }

  private async Excelファイル出力前入力チェックをする(): Promise<void> {
    if (this.バリデーション結果.hasErrors) {
      this.バリデーションエラーを表示する();
      return;
    }

    this.Excel出力確認ダイアログを開く();
  }

  private async Excelファイルを出力する(): Promise<void> {
    this.Excel出力確認ダイアログを閉じる();
    await progress(this.入出庫集計一覧の出力);
  }

  private async 入出庫集計一覧の出力(): Promise<void> {
    await download.入出庫集計一覧を出力する('入出庫集計一覧.xlsx', this.入出庫照会絞込条件);
  }

  private APIアラートメッセージを取得(data: any): string[] {
    let メッセージ = [data.message];
    for (const エラー of data.errors) {
      メッセージ = メッセージ.concat(['・' + エラー]);
    }
    return メッセージ;
  }

  private APIアラートメッセージを表示する(error: any): void {
    const APIアラートメッセージ = this.APIアラートメッセージを取得(error.data);
    this.アラートダイアログを表示する(APIアラートメッセージ);
  }

  private バリデーションエラーを表示する() {
    this.アラートダイアログを表示する(this.バリデーション結果.getMessages(false));
  }
}
